const mergeObject = require('hobbit-base/modules/plugins/mergeObject');
const { ROUTE_REQUIRE_ENUM } = require('hobbit-base/components/bizs/main/constant');
const engineBaseConfig = require('hobbit-engine-base/modules/config');
const appName = require('../package.json').name;

const ROUTE_PREFIX = '/([a-z]{2}-[a-z]{2})?/school';

const { MUST_LOGIN, SELF_CHILD } = ROUTE_REQUIRE_ENUM;

module.exports = mergeObject(engineBaseConfig, {
  runtime: process.env.VUE_APP_RUNTIME,
  site: {
    publicPath: `https://s.vipkidstatic.com/fe-static/${appName}/prod/${process.env.VUE_APP_DRONE || 'default'}/`,
    noLangPath: true,
  },
  log: {
    appName,
  },
  routes: {
    // #region ucenter
    homeroom: {
      index: 1,
      path: `${ROUTE_PREFIX}/ucenter/homeroom/`,
      view: '/ucenter/homeroom/homeroom.vue',
      mview: '/ucenter/homeroom/m-homeroom.vue',
      meta: {
        require: SELF_CHILD,
      },
    },
    onboardwelcome: {
      index: 2,
      path: `${ROUTE_PREFIX}/ucenter/onboardwelcome/`,
      view: '/ucenter/onboardwelcome/onboardwelcome.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
      meta: {
        require: MUST_LOGIN,
      },
    },
    onboardtodo: {
      index: 3,
      path: `${ROUTE_PREFIX}/ucenter/onboardtodo/`,
      view: '/ucenter/onboardtodo/onboardtodo.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
      meta: {
        require: MUST_LOGIN,
      },
    },
    learningEffect: {
      index: 9,
      path: `${ROUTE_PREFIX}/ucenter/learningeffect/`,
      view: '/ucenter/learningEffect/learningEffect.vue',
      mview: '/ucenter/learningEffect/m-learningEffect.vue',
      meta: {
        require: MUST_LOGIN,
        agentAuth: ['booking'],
      },
    },
    learningRanking: {
      index: 10,
      path: `${ROUTE_PREFIX}/ucenter/learningranking/`,
      view: '/ucenter/learningRanking/learningRanking.vue',
      mview: '/ucenter/learningRanking/m-learningRanking.vue',
      meta: {
        require: MUST_LOGIN,
      },
    },
    learningShare: {
      index: 11,
      path: `${ROUTE_PREFIX}/ucenter/learningshare/`,
      view: '/ucenter/learningShare/learningShare.vue',
      // revertLangOption: {
      //   'ar-ae': 'en-us',
      // },
      meta: {
        require: MUST_LOGIN,
      },
    },
    mySchedule: {
      index: 301,
      path: `${ROUTE_PREFIX}/ucenter/myschedule/`,
      view: '/ucenter/myschedule/myschedule.vue',
      mview: '/ucenter/myschedule/m_myschedule.vue',
      meta: {
        // agentAuth: ['booking', 'booktrial'],
        require: SELF_CHILD,
      },
    },
    completedClass: {
      index: 302,
      path: `${ROUTE_PREFIX}/ucenter/completedclass/`,
      view: '/ucenter/completedclass/completedclass.vue',
      mview: '/ucenter/completedclass/m_completedclass.vue',
      meta: {
        agentAuth: ['booking', 'booktrial'],
        require: SELF_CHILD,
      },
    },
    classHour: {
      index: 40,
      path: `${ROUTE_PREFIX}/ucenter/classhour/`,
      view: '/ucenter/classHour/classHour.vue',
      preloads: ['classHourDetail', 'classPackageDetail', 'subscription'],
      revertLangOption: {
        // 'ar-ae': 'en-us',
      },
      meta: {
        agentAuth: ['booking', 'booktrial'],
        require: MUST_LOGIN,
      },
    },
    classHourDetail: {
      index: 41,
      path: `${ROUTE_PREFIX}/ucenter/classhourdetail/`,
      view: '/ucenter/classHourDetail/classHourDetail.vue',
      mview: '/ucenter/classHourDetail/m_classHourDetail.vue',
      preloads: ['classPackageDetail', 'subscription'],
      meta: {
        agentAuth: ['booking', 'booktrial'],
        require: SELF_CHILD,
      },
    },
    classPackageDetail: {
      index: 42,
      path: `${ROUTE_PREFIX}/ucenter/classpackagedetail/`,
      view: '/ucenter/classPackageDetail/classPackageDetail.vue',
      mview: '/ucenter/classPackageDetail/m-classPackageDetail.vue',
      preloads: ['classHourDetail', 'subscription'],
      meta: {
        agentAuth: ['booking', 'booktrial'],
        require: MUST_LOGIN,
      },
    },
    subscription: {
      index: 43,
      path: `${ROUTE_PREFIX}/ucenter/subscription/`,
      view: '/ucenter/subscription/subscription.vue',
      preloads: ['classHourDetail', 'classPackageDetail'],
      meta: {
        require: MUST_LOGIN,
      },
    },
    minimumConsumption: {
      index: 44,
      path: `${ROUTE_PREFIX}/ucenter/minimumconsumption/`,
      view: '/ucenter/minimumConsumption/minimumConsumption.vue',
      mview: '/ucenter/minimumConsumption/m_minimumConsumption.vue',
      meta: {
        agentAuth: ['booking', 'booktrial', 'minimumconsumption'],
        require: MUST_LOGIN,
      },
    },
    // #endregion
    // #region bookclass
    // qualityTeacher: {
    //   index: 240,
    //   path: `${ROUTE_PREFIX}/bookclass/qualityteacher/`,
    //   view: '/bookclass/qualityteacher/qualityteacher.vue',
    //   revertLangOption: {
    //     'ar-ae': 'en-us',
    //   },
    //   meta: {
    //     agentAuth: ['booking', 'booktrial'],
    //     require: MUST_LOGIN,
    //   },
    // },
    courseCardList: {
      index: 101,
      path: `${ROUTE_PREFIX}/bookclass/coursecardlist/`,
      view: '/bookclass/courseCardList/courseCardList.vue',
      preloads: ['courseInformationDetails', 'seriesCourseInformationDetails'],
      meta: {
        agentAuth: ['booking'],
      },
    },
    courseInformationDetails: {
      index: 102,
      path: `${ROUTE_PREFIX}/bookclass/courseinformationdetails/`,
      view: '/bookclass/courseInformationDetails/courseInformationDetails.vue',
      mview: '/bookclass/courseInformationDetails/m_courseInformationDetails.vue',
      meta: {
        agentAuth: ['booking'],
      },
    },
    seriesCourseInformationDetails: {
      index: 102,
      path: `${ROUTE_PREFIX}/bookclass/seriescourseinformationdetails/`,
      view: '/bookclass/seriesCourseInformationDetails/seriesCourseInformationDetails.vue',
      mview: '/bookclass/seriesCourseInformationDetails/m_seriesCourseInformationDetails.vue',
      meta: {
        agentAuth: ['booking', 'booktrial'],
      },
    },
    // 无序课详情页
    unorderedCoursesDetails: {
      index: 102,
      path: `${ROUTE_PREFIX}/bookclass/unorderedCoursesDetails/`,
      view: '/bookclass/unorderedCoursesDetails/unorderedCoursesDetails.vue',
      mview: '/bookclass/unorderedCoursesDetails/m_unorderedCoursesDetails.vue',
      revertLangOption: {
        // 'ar-ae': 'en-us',
      },
      meta: {
        agentAuth: ['booking'],
      },
    },
    // AI 课列表页
    AICourseList: {
      index: 102,
      path: `${ROUTE_PREFIX}/bookclass/aicourselist/`,
      view: '/bookclass/aicourselist/aicourselist.vue',
      mview: '/bookclass/aicourselist/maicourselist.vue',
      keepAlive: true,
      revertLangOption: {
        'ar-ae': 'en-us',
      },
      meta: {
        agentAuth: ['booking'],
        require: SELF_CHILD,
      },
    },
    // AI详情页
    aiCourseDetails: {
      index: 103,
      path: `${ROUTE_PREFIX}/bookclass/aicoursedetails/`,
      view: '/bookclass/aicoursedetails/aicoursedetails.vue',
      revertLangOption: {
        // 'ar-ae': 'en-us',
      },
      meta: {
        agentAuth: ['booking'],
        require: SELF_CHILD,
      },
    },
    // 主修课 byts 页面
    bookmajorclass: {
      index: 241,
      path: `${ROUTE_PREFIX}/bookclass/major/`,
      view: '/bookclass/majortimeslot/majortimeslot.vue',
      mview: '/bookclass/majortimeslot/m_majortimeslot.vue',
      preloads: ['booktrialclass', 'majortsteachers'],
      meta: {
        agentAuth: ['booking', 'booktrial'],
        require: SELF_CHILD,
      },
    },
    // 主修课 byts 选老师 页面
    majortsteachers: {
      index: 242,
      path: `${ROUTE_PREFIX}/bookclass/major/tsteachers/`,
      view: '/bookclass/majortsteachers/majortsteachers.vue',
      mview: '/bookclass/majortsteachers/m_majortsteachers.vue',
      preloads: ['booktrialclass', 'bookmajorclass'],
      revertLangOption: {
        // 'ar-ae': 'en-us',
      },
      meta: {
        agentAuth: ['booking', 'booktrial', 'ronicaBook'],
        require: SELF_CHILD,
      },
    },
    // 老师详情
    // teacherdetail: {
    //   index: 242,
    //   path: `${ROUTE_PREFIX}/bookclass/teacherdetail/`,
    //   view: '/bookclass/teacherdetail/teacherdetail.vue',
    //   mview: '/bookclass/teacherdetail/m_teacherdetail.vue',
    //   preloads: ['booktrialclass', 'bookmajorclass', 'majortsteachers'],
    //   meta: {
    //     agentAuth: ['booking', 'booktrial'],
    //   },
    // },
    // 主修课 by teacher 老师列表
    majorteachers: {
      index: 241,
      path: `${ROUTE_PREFIX}/bookclass/major/teachers/`,
      view: '/bookclass/majorteachers/majorteachers.vue',
      mview: '/bookclass/majorteachers/m_majorteachers.vue',
      preloads: ['booktrialclass', 'bookmajorclass'],
      revertLangOption: {
        // 'ar-ae': 'en-us',
      },
      meta: {
        agentAuth: ['booking', 'booktrial', 'ronicaBook'],
        require: SELF_CHILD,
      },
    },
    // 主修课 by teacher 老师约课
    majorteachertimeslot: {
      index: 242,
      path: `${ROUTE_PREFIX}/bookclass/major/timeslot/`,
      view: '/bookclass/majorteachertimeslot/majorteachertimeslot.vue',
      mview: '/bookclass/majorteachertimeslot/m_majorteachertimeslot.vue',
      preloads: ['booktrialclass', 'bookmajorclass', 'majorteachers', 'teacherdetail'],
      revertLangOption: {
        // 'ar-ae': 'en-us',
      },
      meta: {
        agentAuth: ['booking', 'booktrial', 'ronicaBook'],
        require: SELF_CHILD,
      },
    },
    // 自动约课计划
    majorautobook: {
      index: 243,
      path: `${ROUTE_PREFIX}/bookclass/major/autobook/`,
      view: '/bookclass/majorautobook/majorautobook.vue',
      mview: '/bookclass/majorautobook/m_majorautobook.vue',
      preloads: ['booktrialclass', 'majortsteachers', 'bookmajorclass'],
      meta: {
        agentAuth: ['booking', 'booktrial'],
        require: SELF_CHILD,
      },
    },
    // 约课入口页面
    majorentry: {
      index: 241,
      path: `${ROUTE_PREFIX}/bookclass/major/entry/`,
      view: '/bookclass/majorentry/majorentry.vue',
      preloads: ['bookmajorclass', 'majortsteachers'],
      meta: {
        agentAuth: ['booking'],
        require: SELF_CHILD,
      },
    },
    // m端约课老师列表
    bookteacherlist: {
      index: 241,
      path: `${ROUTE_PREFIX}/bookclass/bookteacherlist/`,
      view: '/bookclass/bookteacherlist/bookteacherlist.vue',
      preloads: ['majorteachertimeslot'],
      meta: {
        agentAuth: ['booking'],
        require: SELF_CHILD,
      },
    },
    // m端搜索老师页
    majorteachersearch: {
      index: 242,
      path: `${ROUTE_PREFIX}/bookclass/major/search/`,
      mview: '/bookclass/majorteachersearch/majorteachersearch.vue',
      preloads: ['majortsteachers', 'teacherdetail'],
      revertLangOption: {
        'ar-ae': 'en-us',
      },
      meta: {
        agentAuth: ['booking', 'booktrial'],
        require: SELF_CHILD,
      },
    },
    // #endregion
    // #region course
    classMaterials: {
      index: 397,
      path: `${ROUTE_PREFIX}/course/classmaterials/`,
      view: '/course/classMaterials/classMaterials.vue',
      mview: '/course/classMaterials/m-classMaterials.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
      meta: {
        require: MUST_LOGIN,
      },
    },
    classContentDetail: {
      index: 398,
      path: `${ROUTE_PREFIX}/course/classcontentdetail/`,
      view: '/course/classContentDetail/classContentDetail.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
      meta: {
        require: MUST_LOGIN,
      },
    },
    replays: {
      index: 399,
      path: `${ROUTE_PREFIX}/course/replays/`,
      view: '/course/replays/replays.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
      meta: {
        require: MUST_LOGIN,
      },
    },
    shareVideo: {
      index: 399,
      path: `${ROUTE_PREFIX}/course/sharevideo/`,
      view: '/course/shareVideo/shareVideo.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
      meta: {
        require: MUST_LOGIN,
      },
    },
    resourcebox: {
      index: 399,
      path: `${ROUTE_PREFIX}/service/resourcebox/`,
      view: '/service/resourcebox/resourcebox.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
      meta: {
        require: MUST_LOGIN,
      },
    },
    classroom: {
      index: 200,
      path: `${ROUTE_PREFIX}/course/classroom/`,
      view: '/course/classroom/classroom.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
    },
    AIClassroom: {
      index: 399,
      path: `${ROUTE_PREFIX}/course/aiclassroom/`,
      view: '/course/AIClassroom/AIClassroom.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
      meta: {
        require: MUST_LOGIN,
      },
    },
    classFeedback: {
      index: 301,
      path: `${ROUTE_PREFIX}/course/classfeedback/`,
      view: '/course/classFeedback/classFeedback.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
      meta: {
        require: MUST_LOGIN,
      },
    },
    // UA报告页
    classUnitReport: {
      index: 301,
      path: `${ROUTE_PREFIX}/course/classunitreport/`,
      view: '/course/classUnitReport/classUnitReport.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
      meta: {
        require: MUST_LOGIN,
      },
    },
    // UA报告的分数详情页
    unitSourceDetail: {
      index: 302,
      path: `${ROUTE_PREFIX}/course/unitsourcedetail/`,
      view: '/course/unitSourceDetail/unitSourceDetail.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
      meta: {
        require: MUST_LOGIN,
      },
    },
    myExam: {
      index: 303,
      path: `${ROUTE_PREFIX}/ucenter/myexam/`,
      view: '/ucenter/myExam/myExam.vue',
    },
    // 学习资格证书
    learningCertification: {
      index: 303,
      path: `${ROUTE_PREFIX}/course/learningCertification/`,
      view: '/course/learningCertification/learningCertification.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
    },
    itTest: {
      index: 100,
      path: `${ROUTE_PREFIX}/course/ittest/`,
      view: '/course/itTest/itTest.vue',
      revertLangOption: {
        'ar-ae': 'en-us',
      },
    },
    // #endregion
  },
  abtest: {},
  // 业务自定义配置信息
  custom: {
    // === 禁用IM的路由 ===
    disableIMRoutes: {
      pc: {
        classroom: true,
        classFeedback: true,
        unitSourceDetail: true,
        classUnitReport: true,
        replays: true,
        studentLevelQuestion: true,
        aicourselist: true,
        AIClassroom: true,
        onboardwelcome: true,
        onboardtodo: true,
        learningTime: true,
        learningShare: true,
        learningCertification: true,
        myExam: true,
        learningEffect: true,
        learningRanking: true,
      },
      m: {
        bookteacherlist: true,
        booktrialclass: true,
        trialteacherlist: true,
        bookmajorclass: true,
        majortsteachers: true,
        majorentry: true,
        majorteachers: true,
        majorteachertimeslot: true,
        majorteachersearch: true,
        classfeedback: true,
        unitSourceDetail: true,
        classUnitReport: true,
        replays: true,
        classMaterials: true,
        studentLevelQuestion: true,
        unorderedCoursesDetails: true,
        aicourselist: true,
        onboardwelcome: true,
        onboardtodo: true,
        resourcebox: true,
        learningTime: true,
        learningShare: true,
        learningCertification: true,
        myExam: true,
        learningEffect: true,
        learningRanking: true,
      },
    },
    // === 禁用系统弹窗的路由 ===
    disableSystemNoticeRoutes: {
      learningShare: true,
    },
    cmsApiBase: '/rest/gw/mgt/api/cms',
    hideSupplementPopKey: 'hideSupplementPop',
  },
});
